import { Tooltip } from "./utils-DjFceY3H.js";
import { Check, Minus } from "./icons-DDR9dFSr.js";
import { FieldBox } from "./FieldBox-DdSdJ3ZN.js";
import { useId } from "react";
import { cva } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
import { Indicator, Root } from "@radix-ui/react-checkbox";
// src/components/Checkbox/styles.ts
const rootVariants = cva([
	"tailwindcss-preflight",
	"tw:flex",
	"tw:items-center",
	"tw:justify-center",
	"tw:peer",
	"tw:size-4",
	"tw:shrink-0",
	"tw:cursor-pointer",
	"tw:border",
	"tw:border-solid",
	"tw:disabled:opacity-disabled",
	"tw:disabled:cursor-not-allowed",
	"tw:rounded",
	"tw:border-input",
	"tw:transition-colors",
	"tw:data-[state=checked]:bg-primary",
	"tw:data-[state=checked]:border-primary",
	"tw:data-[state=indeterminate]:bg-primary",
	"tw:data-[state=indeterminate]:border-primary",
	"tw:focus-visible:outline-hidden",
	"tw:focus-visible:border-primary",
	"tw:focus-visible:ring-2",
	"tw:focus-visible:ring-ring/50"
]);
const indicatorVariants = cva([
	"tw:group",
	"tw:flex",
	"tw:items-center",
	"tw:text-primary-foreground"
]);
// src/components/Checkbox/Checkbox.tsx
function Checkbox({ className, id: idProp, children, description, variant, position, tooltip, tooltipPlacement = "top", ...rest }) {
	const fallbackId = useId();
	const id = idProp?.toString() ?? fallbackId;
	const checkboxElement = /* @__PURE__ */ jsx(Root, {
		id,
		...rest,
		className: rootVariants({ className }),
		children: /* @__PURE__ */ jsxs(Indicator, {
			className: indicatorVariants(),
			children: [/* @__PURE__ */ jsx(Check, { className: "tw:hidden tw:size-3 tw:stroke-[4px] tw:group-data-[state=checked]:block" }), /* @__PURE__ */ jsx(Minus, { className: "tw:hidden tw:size-3 tw:stroke-[4px] tw:group-data-[state=indeterminate]:block" })]
		})
	});
	const rendered = !children ? checkboxElement : /* @__PURE__ */ jsxs(FieldBox, {
		htmlFor: id,
		variant,
		position,
		control: checkboxElement,
		children: [/* @__PURE__ */ jsx(FieldBox.Title, { children }), description && /* @__PURE__ */ jsx(FieldBox.Description, { children: description })]
	});
	if (!tooltip) return rendered;
	return /* @__PURE__ */ jsx(Tooltip, {
		tooltip,
		placement: tooltipPlacement,
		triggerAsChild: !!children,
		children: rendered
	});
}
export { Checkbox };

//# sourceMappingURL=Checkbox-B2jLlyaO.js.map